var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json-editor"},[_c('textarea',{ref:"textarea"}),(_vm.jsonError)?_c('div',{staticClass:"json-editor__error"},[_vm._v(_vm._s(_vm.jsonError))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }